import { useCallback, useRef, useState } from "react";

export default function useSubmitting() {
  const [submitting, setSubmitting] = useState(false);
  const lockRef = useRef(false);

  const wrap = useCallback((fn: (...args: any[]) => any) => {
    return async (...args: any[]) => {
      if (lockRef.current) return;
      lockRef.current = true;
      setSubmitting(true);
      try {
        // Support both sync and async handlers
        await Promise.resolve(fn(...args));
      } finally {
        lockRef.current = false;
        setSubmitting(false);
      }
    };
  }, []);

  return [submitting, wrap] as const;
}
